document.addEventListener('DOMContentLoaded', function() {
  // Check if we are on a product page by looking for the quote button
  const quoteBtn = document.getElementById('add-to-quote-btn');
  if (!quoteBtn) {
    return; // Exit if the button is not found
  }

  const productForm = quoteBtn.closest('product-form');
  const productInfoElement = document.querySelector('product-info[data-product-id]');

  if (!productForm || !productInfoElement) {
    console.error('Quote system elements not found. Aborting.');
    return;
  }

  // --- Aviso "Agregado a tu cotización" (no bloquea la página) ---
  const toast = document.querySelector('[data-quote-toast]');
  const toastLive = document.querySelector('[data-quote-toast-live]');
  const TOAST_MS = 5000;
  let toastTimer = null;

  // Se mueve a <body> para que ningún contenedor con transform rompa el position: fixed.
  if (toast) document.body.appendChild(toast);

  function positionToast() {
    // El aviso se coloca justo encima de la píldora flotante (WhatsApp + Cotizador),
    // que es a donde "llega" el producto. Sin píldora, queda abajo a la derecha.
    const pill = document.querySelector('[data-floating-quote]');
    const rect = pill ? pill.getBoundingClientRect() : null;
    const bottom = rect && rect.height ? window.innerHeight - rect.top + 12 : 16;
    toast.style.setProperty('--toast-bottom', Math.round(bottom) + 'px');
  }

  function hideToast() {
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.classList.remove('is-visible');
  }

  function scheduleHide() {
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, TOAST_MS);
  }

  function showToast(productTitle) {
    if (!toast) return;
    toast.querySelector('[data-quote-toast-product]').textContent = productTitle || '';
    positionToast();
    toast.classList.add('is-visible');
    if (toastLive) toastLive.textContent = 'Agregado a tu cotización: ' + (productTitle || '');
    scheduleHide();

    document
      .querySelectorAll('#quote-icon-bubble .quote-count-bubble, [data-floating-quote-count]')
      .forEach((bubble) => {
        bubble.classList.remove('is-bumped');
        void bubble.offsetWidth; // reinicia la animación
        bubble.classList.add('is-bumped');
      });
  }

  if (toast) {
    toast.querySelector('[data-quote-toast-close]').addEventListener('click', hideToast);
    // Mientras el cliente lo mira o navega con teclado, no desaparece.
    toast.addEventListener('pointerenter', () => clearTimeout(toastTimer));
    toast.addEventListener('pointerleave', scheduleHide);
    toast.addEventListener('focusin', () => clearTimeout(toastTimer));
    toast.addEventListener('focusout', scheduleHide);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toast.classList.contains('is-visible')) hideToast();
    });
  }

  // --- Button Click Handling ---
  quoteBtn.addEventListener('click', function() {
    const variantIdInput = productForm.querySelector('input[name="id"]');
    const quantityInput = productForm.querySelector('input[name="quantity"]');

    // Fallback for themes without a specific quantity input near the form
    const quantityEl = document.getElementById(`Quantity-${productInfoElement.dataset.section}`) || document.querySelector('.quantity__input');

    const variantId = variantIdInput ? variantIdInput.value : null;
    const quantity = quantityInput ? quantityInput.value : (quantityEl ? quantityEl.value : 1);

    if (!variantId) {
      console.error('Could not find variant ID.');
      alert('Error: No se pudo seleccionar la variante del producto.');
      return;
    }

    // --- Gather Product Information ---
    // This part can be theme-dependent. We make some safe assumptions.
    const productTitle = document.querySelector('.product__title h1, .product__title h2')?.textContent.trim();
    const priceElement = document.querySelector(`#price-${productInfoElement.dataset.section} .price-item--regular, #price-${productInfoElement.dataset.section} .price-item--sale`);
    const skuElement = document.querySelector(`#Sku-${productInfoElement.dataset.section}`);
    const imageElement = document.querySelector('.product__media-gallery .product-media-gallery__image, .product__media-wrapper img');

    // --- Clean up SKU ---
    let skuText = skuElement ? skuElement.textContent.trim() : 'N/A';
    if (skuText.toLowerCase().startsWith('sku:')) {
      skuText = skuText.substring(4).trim();
    }

    // --- Get Variant Title ---
    let variantTitle = '';
    // Primary method: Read from the data script tag in the variant picker.
    const selectedVariantScript = document.querySelector('[data-selected-variant]');
    if (selectedVariantScript) {
      try {
        const variantData = JSON.parse(selectedVariantScript.textContent);
        if (variantData && variantData.title && variantData.title.toLowerCase() !== 'default title') {
          variantTitle = variantData.title;
        }
      } catch (e) {
        console.error('Could not parse selected variant JSON:', e);
      }
    }

    // Fallback method: Try to find the selected radio button's label.
    if (!variantTitle) {
      const variantPicker = document.querySelector('variant-radios, variant-selects');
      if (variantPicker) {
        const selectedOption = variantPicker.querySelector('input:checked + label');
        if (selectedOption) {
          variantTitle = selectedOption.textContent.trim();
        }
      }
    }

    const quantityMultiple = parseInt(productInfoElement.dataset.quantityMultiple, 10) || 0;
    const quantityMin = parseInt(productInfoElement.dataset.quantityMin, 10) || 0;

    const productInfo = {
      title: productTitle || 'Producto Desconocido',
      price: priceElement ? priceElement.textContent.trim() : 'N/A',
      sku: skuText,
      variantId: variantId,
      variantTitle: variantTitle,
      quantity: parseInt(quantity, 10),
      imageUrl: imageElement ? imageElement.src.split('?')[0] + '?width=100' : '',
      url: window.location.origin + productInfoElement.dataset.url,
      quantityMultiple: quantityMultiple > 1 ? quantityMultiple : 0,
      quantityMin: quantityMin > 1 ? quantityMin : 0
    };

    window.QuoteManager.addToQuote(variantId, quantity, productInfo);

    // Dispatch a custom event so other parts of the site can react
    document.dispatchEvent(new CustomEvent('quote:changed'));

    showToast(productInfo.title);
  });
});
